// Naming v2 (Creative Name Generator) switch, read by the Export tab (name builder) and Settings (model + preview).
// false => v1 format (PERSONA-/CAT-/…Clean-N).
export const NAME_FORMAT_V2 = true;
